import AddIcon from "@mui/icons-material/Add";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import RestoreIcon from "@mui/icons-material/Restore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useCSVReader } from "react-papaparse";
import { useDispatch, useSelector } from "react-redux";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
// import Drawer from '../../components/Drawer'
import { dateConvert } from "../../helper/dateConverter";
import Body from "../../layout/Body";
import { getSubCategoryAction } from "../../redux/toolkit/sub-category/getSubCategory";
import { getAllSubCategoryAction } from "../../redux/toolkit/sub-category/getSubAllCategory";
import { getAllQuestionAnswerAction } from "../../redux/toolkit/question-answer/getAllQuestionAnswer";
import { getSingleQuestionAnswerAction } from "../../redux/toolkit/question-answer/getSingleQuestionAnswer";
import { uploadQnsAnsAction } from "../../redux/toolkit/question-answer/uploadQnsAns";
import { useStyles } from "../../theme/theme";
import CreateDefaultQns from "./CreateDefaultQns";
import CreateQuestionAnswer from "./CreateQuestionAnswer";
import CreateMultipleQnA from "./CreateMultipleQnA";
import DeleteQns from "./DeleteQns";
import ReStoreQns from "./ReStoreQns";
import UpdateQnsAns from "./UpdateQnsAns";
import { useNavigate } from "react-router-dom";
import { deleteMultipleQuestionAnswerAction } from "../../redux/toolkit/question-answer/deleteMultipleQna";
import DeleteMulQnA from "./DeleteMulQnA";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import InputLabel from "@mui/material/InputLabel";
// import MenuItem from '@mui/material/MenuItem';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import moment from "moment";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/qns-ans"
      >
        Profile Question
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      Profile Question
    </Typography>
  </Stack>
);

let cat_id = "";

export default function QuestionAnswer() {
  // state--->
  const {
    register,
    getValues,
    formState: { errors },
  } = useForm({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const qnsAns = useSelector((state) => state.getAllQuestionAnswer);
  const { data: qnsData, loading: qnsLoading, total } = qnsAns;

  const getCat = useSelector((state) => state.getAllSubCategory);
  const { data: getCatData } = getCat;
  const uploadQnsAns = useSelector((state) => state.uploadQnsAns);
  const { status: uploadQnsAnsStatus, message: uploadQnsAnsMessage } =
    uploadQnsAns;
  const permission = useSelector((state) => state.getPermissionAndRole);
  const { data: permissionData } = permission;

  let can_delete = JSON.parse(localStorage.getItem("ss_active_usr"))?.settings
    ?.can_delete;
  let super_admin = permissionData?.role;

  const [createQns, setCreateQns] = useState(false);
  const [multipleQns, setMultipleQns] = useState(false);
  const [createDefaultQns, setCreateDefaultQns] = useState(false);
  const [updateQns, setUpdateQns] = useState(false);
  const [delQns, setDelQns] = useState(false);
  const [delMulQns, setDelMulQns] = useState(false);
  const [catMenu, setCatMenu] = useState(false);
  const [anchorCatMenu, setAnchorCatMenu] = useState();
  const [ativeFilter, setActiveFilter] = useState(false);
  const [restoreCat, setRestoreCat] = useState(false);
  const [qns_id, setqns_id] = useState("");
  const classes = useStyles();
  const [date, setDate] = useState({
    start: null,
    end: null,
  });
  const [qnsCSVData, setQnsCSVData] = useState([]);
  const [snack, setSnack] = useState(false);
  const { CSVReader } = useCSVReader();
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  const [selectedIds, setSelectedIds] = useState([]);
  const [diff, setDiff] = useState("");

  const handleSelectionChange = (newSelection) => {
    // 'newSelection' contains the IDs of the selected rows
    setSelectedIds((prev) => newSelection);
  };

  // useEffect(()=>{

  // },[selectedIds])

  const deleteMultipleHandler = () => {
    setDelMulQns(true);
    dispatch(
      deleteMultipleQuestionAnswerAction({
        questionIds: selectedIds,
        isDelete: true,
      })
    );
  };

  const qnsDataGridColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 30,
      headerClassName: "super-app-theme--header",
      // renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1,
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "question",
      headerName: "Question",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "edit",
      headerName: "Edit Q & A",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setUpdateQns(true);
              dispatch(getSingleQuestionAnswerAction(params?.row?._id));
            }}
          >
            <EditIcon color="primary" />
          </IconButton>
        );
      },
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      hide: ativeFilter,
    },

    // {
    //   field: 'delete', headerName: 'Delete Q & A', renderCell: () => {
    //     return (
    //       <IconButton
    //         onClick={(params) => {
    //           setDelQns(true)
    //           setqns_id(params?.row?._id)
    //         }}>
    //         <DeleteIcon color='error' /></IconButton>
    //     )
    //   },
    //   flex: 1,
    //   minWidth: 150,
    //   headerClassName: 'super-app-theme--header',
    // },

    {
      field: "created_at",
      headerName: "Created_at",
      flex: 1,
      minWidth: 210,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.created_at)
              .local()
              .format("DD-MM-YYYY hh:mm:ss A")}
          </Typography>
        );
      },
    },
  ];

  // function

  // use effect
  useEffect(() => {
    dispatch(getAllQuestionAnswerAction({ is_deleted: false ,page:pageState.page,limit:pageState.pageSize}));
  }, [dispatch ,pageState.page,pageState.pageSize]);



  const handleChange = (event) => {
    setDiff(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin| Profile Question</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      {/* <Drawer /> */}
      <Body>
        {/* <Card sx={{ p: 3, bgcolor: '#071D45', color: '#fff' }}>
          <Typography variant='h6'>Q & A section</Typography>
          <Typography variant='subtitle1'>You can create question and answer from here.</Typography>
          <Stack direction='row' spacing={2} sx={{ mt: 2 }}>
            <Button sx={{ bgcolor: '#fff', color: '#000' }} variant='contained' onClick={() => { setCreateQns(true); dispatch(getSubCategoryAction({ is_deleted: false })) }}>Create Question</Button>
            <Button variant='contained' onClick={() => { setCreateDefaultQns(true) }} color='error' > Create Default Question</Button>
          </Stack>
        </Card> */}

        <Stack direction="row" justifyContent="end" alignItems="flex-end">
          {/* <Button variant="outlined" startIcon={<FilterListIcon />} onClick={() => { setIsFilterArea(!isFilterArea) }}>
                        filter by date
                    </Button> */}
          {/* <Button variant="contained" color="btn" startIcon={<AddIcon />} onClick={() => { setMultipleQns(true); dispatch(getSubCategoryAction({ is_deleted: false })) }}>
                        create Multiple Q & A
                    </Button> */}
          <Button
            variant="contained"
            color="btn"
            startIcon={<AddIcon />}
            onClick={() => {
              setCreateQns(true);
              dispatch(getSubCategoryAction({ is_deleted: false }));
            }}
          >
            create Q & A
          </Button>
        </Stack>

        {/* table list */}

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              // marginTop: 2,
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={qnsData}
              autoHeight
              columns={qnsDataGridColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={qnsLoading ? <LoadingUI /> : false}
              onCellClick={(params) => {
                setqns_id(params?.row?._id);
              }}
              // checkboxSelection
              onSelectionModelChange={handleSelectionChange}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {/* <Button variant="contained" disabled={selectedIds?.length === 0 ? true : false} onClick={() => deleteMultipleHandler()}>Delete Selected Q&A</Button> */}

        {/* crud */}
        <CreateQuestionAnswer state={createQns} setState={setCreateQns} />
        <CreateDefaultQns
          state={createDefaultQns}
          setState={setCreateDefaultQns}
        />
        <UpdateQnsAns
          qns_id={qns_id}
          state={updateQns}
          setState={setUpdateQns}
        />
        <DeleteQns qns_id={qns_id} state={delQns} setState={setDelQns} />
        <DeleteMulQnA
          qns_id={qns_id}
          state={delMulQns}
          setState={setDelMulQns}
        />
        <ReStoreQns
          qns_id={qns_id}
          state={restoreCat}
          setState={setRestoreCat}
        />
        {/* <CreateMultipleQnA state={multipleQns} setState={setMultipleQns} /> */}
      </Body>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={uploadQnsAnsStatus}
        message={uploadQnsAnsMessage}
      />
    </>
  );
}
